import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49a27367")

_pushScopeId("data-v-49a27367")
const _hoisted_1 = { class: "confirm--container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("i", {
      ref: "trigger",
      class: {
                'text--delete' : _ctx.show && ((_ctx.type === 'custom' && _ctx.behavior === 'reject') || _ctx.type==='delete' || _ctx.type==='ts-deny'),
                'text--ok'     : _ctx.show && ((_ctx.type === 'custom' && _ctx.behavior === 'confirm') || _ctx.type==='ok' || _ctx.type==='ts-confirm' || _ctx.type==='ts-select'),
                'text--restore': _ctx.show && _ctx.type==='restore',
                'icon-trash': _ctx.type==='delete',
                'icon-select': _ctx.type==='ok',
                'icon-history': _ctx.type==='restore',
                'icon-calendar-tick': _ctx.type==='ts-confirm' || _ctx.type==='ts-select',
                'icon-calendar-cancel': _ctx.type==='ts-deny',
                [`${_ctx.icon}`]: _ctx.type==='custom'
            },
      title: 
                _ctx.type === 'ok'
                    ? 'Approuver'
                    : _ctx.type === 'restore'
                    ? 'Restorer'
                    : _ctx.type === 'delete'
                    ? 'Retirer'
                    : _ctx.type == 'ts-select'
                    ? 'Sélectionner la plage horaire'
                    : _ctx.type == 'ts-confirm'
                    ? 'Confirmer la réservation'
                    : _ctx.type == 'ts-deny'
                    ? 'Refuser la réservation'
                    : _ctx.msg
            ,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirm && _ctx.toggleConfirm(...args)))
    }, null, 10, ["title"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#popups" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_Popup, {
                key: 0,
                showHeader: false,
                type: _ctx.dropdown,
                style: _ctx.popupFilterPosition
              }, {
                body: _withId(() => [
                  _createVNode("span", {
                    class: ["text", {
                                'back--delete' : (_ctx.type === 'custom' && _ctx.behavior === 'reject') || _ctx.type==='delete' || _ctx.type==='ts-deny',
                                'back--ok'     : (_ctx.type === 'custom' && _ctx.behavior === 'confirm') || _ctx.type==='ok' || _ctx.type==='ts-confirm' || _ctx.type==='ts-select',
                                'back--restore': _ctx.type==='restore'
                            }]
                  }, _toDisplayString(_ctx.confirmStr), 3)
                ]),
                _: 1
              }, 8, ["type", "style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
})